import { Button, Stack, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import type React from "react";

export interface LoadMore {
	page: number;
	pageSize: number;
}

interface MoreResultsButtonProps {
	totalCount: number | undefined;
	pageSize: number | undefined;
	renderedResults: number;
	page: number | undefined;
	loadMore: (newVal: LoadMore) => void;
	isLoading: boolean;
}

export const MoreResultsButton: React.FC<MoreResultsButtonProps> = ({
	totalCount,
	pageSize,
	renderedResults,
	page,
	loadMore,
	isLoading,
}) => {
	if (!totalCount || totalCount === 0 || pageSize === undefined || pageSize === 0 || page === undefined) {
		return null;
	}

  // Loading is done trough expanding size of first page to be loaded :D
  // we even disabled pagination which didn't have pages but looped

	const loadMoreCount = renderedResults + pageSize <= totalCount? pageSize : totalCount - renderedResults;
	const loadMoreCountDisplay = loadMoreCount;

	const handleLoadMore = () => {
    loadMore({ page: 0, pageSize: renderedResults + loadMoreCount });
	};

	if (loadMoreCount > 0) {
		return (
			<Button
				sx={(theme) => ({
					"&.MuiButton-loadingPositionCenter": {
						backgroundColor: theme?.vars?.palette.secondary.main,
						opacity: 0.8,
					},
				})}
				loadingIndicator={
					<Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
						<Typography sx={{ color: "white" }}>Načítám...</Typography>
						<CircularProgress sx={{ color: "white" }} size={20} variant="indeterminate" />
					</Stack>
				}
				loading={isLoading}
				variant="contained"
				color="secondary"
				onClick={handleLoadMore}
			>
				načíst dalších {loadMoreCountDisplay} výsledků
			</Button>
		);
	}

	if (isLoading) {
		return (
			<Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
				<Typography color="textDisabled">Načítám...</Typography>
				<CircularProgress sx={{ color: "grey.400" }} size={20} variant="indeterminate" />
			</Stack>
		);
	}

  return null;
  //
  // Removed by ITUP-71580
  //
	// return (
	// 	<Stack spacing={2} alignItems="center" justifyContent="center">
  //     <Typography color="textDisabled" fontSize={{xs: "2rem", md: "3rem"}} textAlign={"center"} lineHeight={{ xs: '2.3rem', md: undefined}}>
  //
	// 			to je bohužel vše
	// 		</Typography>
	// 		<Typography textAlign="center" fontSize="1rem" color="textDisabled" variant="h3">
	// 			mrzí nás, že jste nenašli, co jste hledali...
	// 			<br />
	// 			zkuste to prosím zase příště, třeba budeme mít to pravé pro vás
	// 		</Typography>
	// 	</Stack>
	// );
};
